import '../InviteButtons.scss';
import { ReactComponent as AddStudentsIcon } from 'images/icons/AddUsers.svg';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useOrganizationStore } from 'stores/Organization/OrganizationStore';
import { Button } from '@trackman/web-shared-components';

export const InviteStudentsButton = ({ intent }: { intent: 'primary' | 'secondary' }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const setIsInviteStudentsModalOpen = useOrganizationStore(state => state.setIsInviteStudentsModalOpen)

  const handleClick = () => {
    setIsInviteStudentsModalOpen(true);
    if (location.pathname !== '/Organization/Students') {
      navigate('/Organization/Students');
    }
  };

  return (
    <Button
      startIcon={<AddStudentsIcon />}
      label={t('InviteStudents', { ns: 'classPage' })}
      className='organization-button'
      onClick={handleClick}
      intent={intent}
    />
  );
};

export default InviteStudentsButton;
